// extracted by mini-css-extract-plugin
export default {"playerContainer":"Audio_playerContainer__pVl4C","songInfo":"Audio_songInfo__N+84l"};